<script>
import InputCheckbox from '../../atoms/inputlib/components/InputCheckbox'
import Spinner from '@/components/atoms/Spinner'
export default {
    name: 'CheckboxPreference',
    components: { InputCheckbox, Spinner },
    props: {
        icon: null,
        label: null,
        desc: null,
        data: null,
        value: null,
        hintText: null,
        information: null,
        required: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        allowEmpty: Boolean,
        loading: Boolean,
        supported: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        isChecked() {
            return this.data ? this.value.includes(this.data) : this.value
        },
        getIcon() {
            return `${this.isChecked ? 'fa-solid' : 'fa-regular'} ${this.icon}`
        },
    },
    methods: {
        onInput(val) {
            this.$emit('input', val)
        },
    },
}
</script>

<template lang="pug">
.checkbox-line
    .d-flex.align-items-center.w-100
        .checkbox-line-icon.mr-3
            icon(:icon="getIcon" :key="`${_uid}-${isChecked}`" :class="isChecked ? 'text-primary' : 'text-99'")
        .d-flex.flex-column.line-1
            .font-weight-semibold.mb-1.font-size-base {{label}}
            .text-26.font-size-xs(v-if="desc") {{desc}}
    transition(name="fade")
        spinner(v-if="loading" size="20")
    input-checkbox(v-if="supported" :value="value" @input="onInput" :data="data" :hint-text="hintText" :required="required" :disabled="disabled" :readonly="readonly" :allow-empty="allowEmpty")
    icon.text-info.cursor-help(
        v-else-if="information"
        icon="fa-solid fa-info-circle"
        size="lg"
        v-tooltip.hover.top.html="information")
</template>
